import { Button } from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import apiList from "./ApiTemplates.json";
import "./SmokeTest.css";

export default function SmokeTest() {
  const apiInput = useRef();
  const tokenInput = useRef();
  const payloadInput = useRef();
  const [prettyResponse, setPrettyResponse] = useState("");
  const [showResponse, setShowResponse] = useState(false);

  async function getAccessToken() {
    try {
      const {data} = await axios.get(
        `${global.REACT_APP_API_ENDPOINT}/smoketest/getToken`,
        {headers: {Authorization: `Bearer YOUR_ACCESS_TOKEN`}}
      );
      console.log("getAccessToken", data.access_token)
      tokenInput.current.value = data.access_token;
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getAccessToken();
  }, []);

  function jsonPrettify(json) {
    const obj = typeof json === "string"
      ? JSON.parse(json)
      : json;
    return JSON.stringify(obj, null, 2);
  };

  function isValidJson(str) {
    try { JSON.parse(str); } 
    catch { return false; }
    return true;
  };

  function showError(element) {
    element.classList.add("has-error");

    setTimeout(() => {
      element.classList.remove("has-error");
    }, 1000);
  };

  function onApiSelect(ev) {
    const apiName = ev.target.value;
    const api = apiList.find(a => a.apiName.toLowerCase() === apiName);
    
    if (api) {
      const payload = jsonPrettify(api.template);
      payloadInput.current.value = payload;
    } else {
      payloadInput.current.value = "";
    }
  };

  async function onSubmit(ev) {
    let hasError = false;

    const apiName = apiInput.current.value;
    const accessToken = tokenInput.current.value;
    const payload = payloadInput.current.value;

    if (!apiName) {
      showError(apiInput.current);
      hasError = true;
    }
    if (!accessToken) {
      showError(tokenInput.current);
      hasError = true;
    }
    if (!payload || !isValidJson(payload)) {
      showError(payloadInput.current);
      hasError = true;
    }

    console.log({apiName, accessToken, payload})

    if (!hasError) {
      try {
        const response = await axios.post(
          `${global.REACT_APP_API_ENDPOINT}/smoketest/validateApi?apiName=${apiName}`,
          { request: JSON.parse(payload) }, 
          { headers: { accessToken }}
        );
        console.log("response", response)
        setPrettyResponse(jsonPrettify(response.data));
        setShowResponse(true);
      } catch (err) {
        console.error(err);
      }
    }
  };

  return (
    <div className="smoke-test">
      <div className="field-group">
        <label htmlFor="token">Access token</label>
        <textarea id="token" name="token" 
          spellCheck={false} 
          ref={tokenInput}></textarea>

        <div className="button-wrapper">
          <Button type="submit" className="get-token-button" onClick={getAccessToken}>
            Generate Token
            <RefreshIcon />
          </Button>
        </div>
      </div>
      
      <div className="field-group">
        <label htmlFor="apiName">Select API</label>
        <select id="apiName" ref={apiInput} name="apiName" onChange={onApiSelect}>
          <option value="">-- Select --</option>
          {apiList
            .filter(api => api.apiName.toLowerCase() !== "lookup")
            .map((api, i) => (
              <option key={i} value={api.apiName.toLowerCase()}>{api.apiName}</option>
          ))}
        </select>
      </div>

      <div className="field-group">
        <label htmlFor="payload">Payload</label>
        <textarea id="payload" name="payload" spellCheck={false} ref={payloadInput}></textarea> 
      </div>

      <div className="button-wrapper">
        <Button type="submit" className="submit-payload-button" onClick={onSubmit}>
          Call API
        </Button>
      </div>

      {showResponse ? (
        <div className="field-group output-section">
          <label htmlFor="output">API Response</label>
          <textarea id="output" name="output" readOnly spellCheck={false} value={prettyResponse}></textarea>
        </div>
      ) : (<></>)}
    </div>
  );
}